import { withAuthenticationRequired } from '@auth0/auth0-react';
import React, { FC, ReactElement } from 'react';
import { Spinner } from 'shamrock-clover-ui';
import styles from './protectedRoute.scss';

interface ProtectedComponentProps {
  children: ReactElement;
}
const ProtectedComponent: FC<ProtectedComponentProps> = ({ children }) => {
  return children;
};

export default withAuthenticationRequired(ProtectedComponent, {
  onRedirecting: () => (
    <div className={styles.spinnerContainer}>
      <Spinner />
    </div>
  ),
  loginOptions: {
    openUrl: (url) => window.location.replace(url),
  },
});
